<!--
    Summary:
        无创产前检测
    ChangeLog:
        Labbor on 2020/2/22 added
-->
<template>
  <div class="v-non-invasive-prenatal-test">
    <banner>
      <img src="../../assets/images/non-invasive-prenatal-test/Header_1920x380_reproductive-health-nipt.jpg"/>
      <div slot="title">{{$t('NonInvasivePrenatalTest.Title')}}</div>
    </banner>


    <div class="p1">
      <h2 class="h2" style="text-align: center; color: #cb3439; text-shadow: 1px 1px 2px #ffffff;">{{$t('NonInvasivePrenatalTest.P1Title')}}</h2>
      <p>&nbsp;</p>
      <h5 class="h5" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 2px #cb3439;">{{$t('NonInvasivePrenatalTest.P1Detail')}}</h5>
    </div>

    <div class="p2">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P2Title')}}</div>
        <img class="img" src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-21.png"/>
        <p>&nbsp;</p>
        <p>{{$t('NonInvasivePrenatalTest.P2Detail')}}</p>
        <p>&nbsp;</p>
        <p>{{$t('NonInvasivePrenatalTest.P2Detail2')}}</p>
        <p>&nbsp;</p>
        <p>
          {{$t('NonInvasivePrenatalTest.P2Detail3')}}
          <strong style="color: #cb3439;">{{$t('NonInvasivePrenatalTest.P2Detail3_2')}}</strong>
        </p>
        <p>&nbsp;</p>
        <p>{{$t('NonInvasivePrenatalTest.P2Detail4')}}</p>
      </img-card>
    </div>

    <div class="p3">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P3Title')}}</div>
        <div class="c box-wrapper">
          <box class="box" has-title>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-22.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P3_1Title')}}</div>
          </box>
          <box class="box" has-title>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-23.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P3_2Title')}}</div>
          </box>
          <box class="box" has-title>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-24.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P3_3Title')}}</div>
          </box>
          <box class="box" has-title>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-25.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P3_4Title')}}</div>
          </box>
          <box class="box" has-title>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-26.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P3_5Title')}}</div>
          </box>
          <div></div>
        </div>
      </img-card>
    </div>

    <div class="p4">
      <p class="p" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 3px #cb3439;"><strong>{{$t('NonInvasivePrenatalTest.P4PreTitle')}}</strong></p>
      <p class="p">&nbsp;</p>
      <h1 class="h1" style="text-align: center; font-size: 36px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P4Title')}}</h1>
      <p class="p">&nbsp;</p>
      <p class="p" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 3px #cb3439;"><strong>{{$t('NonInvasivePrenatalTest.P4Detail')}}</strong></p>
    </div>

    <div class="p5">
      <img-card class="card" has-img>
        <img slot="img" src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-32.png"/>
        <div slot="title">{{$t('NonInvasivePrenatalTest.P5Title')}}</div>
        <p class="p">{{$t('NonInvasivePrenatalTest.P5Detail')}}</p>
        <p class="p">&nbsp;</p>
        <p class="p">{{$t('NonInvasivePrenatalTest.P5Detail2')}}</p>
      </img-card>
    </div>

    <!--  无创产前检测比较  -->
    <div class="p6">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P6Title')}}</div>

        <p class="p">{{$t('NonInvasivePrenatalTest.P6Detail')}}</p>
        <p>&nbsp;</p>
        <div class="table-wrapper">
          <table id="cu-table">
            <tbody>
            <tr>
              <th width="120px">{{$t('NonInvasivePrenatalTest.P6Row1Col1')}}</th>
              <th><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row1Col2')}}</span></th>
              <th>{{$t('NonInvasivePrenatalTest.P6Row1Col3')}}</th>
              <th>{{$t('NonInvasivePrenatalTest.P6Row1Col4')}}</th>
              <th>{{$t('NonInvasivePrenatalTest.P6Row1Col5')}}</th>
            </tr>
            <tr>
              <td>{{$t('NonInvasivePrenatalTest.P6Row2Col1')}}</td>
              <td><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row2Col2')}}</span></td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row2Col3')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row2Col4')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row2Col5')}}</td>
            </tr>
            <tr>
              <td>{{$t('NonInvasivePrenatalTest.P6Row3Col1')}}</td>
              <td><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row3Col2')}}</span></td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row3Col3')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row3Col4')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row3Col5')}}</td>
            </tr>
            <tr>
              <td>{{$t('NonInvasivePrenatalTest.P6Row4Col1')}}</td>
              <td><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row4Col2')}}</span></td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row4Col3')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row4Col4')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row4Col5')}}</td>
            </tr>
            <tr>
              <td>{{$t('NonInvasivePrenatalTest.P6Row5Col1')}}</td>
              <td><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row5Col2')}}</span></td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row5Col3')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row5Col4')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row5Col5')}}</td>
            </tr>
            <tr>
              <td>{{$t('NonInvasivePrenatalTest.P6Row6Col1')}}</td>
              <td><span style="font-size: 16px; color: #cb3439; font-weight: bold;">{{$t('NonInvasivePrenatalTest.P6Row6Col2')}}</span></td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row6Col3')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row6Col4')}}</td>
              <td>{{$t('NonInvasivePrenatalTest.P6Row6Col5')}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </img-card>
    </div>

    <!--  适用人群  -->
    <div class="p7">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P7Title')}}</div>

        <div class="c box-wrapper">
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-09.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_1Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-10.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_2Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-11.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_3Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-12.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_4Detail')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_4Details')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-13.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P7_5Detail')}}</div>
          </box>
          <box class="box">
          </box>
        </div>
      </img-card>
    </div>

    <!--  检测优势  -->
    <div class="p8">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P8Title')}}</div>

        <div class="c box-wrapper">
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-27.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P8_1Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P8_1Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-28.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P8_2Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P8_2Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-29.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P8_3Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P8_3Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-29-.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P8_4Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P8_4Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-test/Reproductive-health_icon-31.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalTest.P8_5Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalTest.P8_5Detail')}}</div>
          </box>
          <box class="box">
          </box>
        </div>
      </img-card>
    </div>

    <!--  常见问题  -->
    <div class="p9">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalTest.P9Title')}}</div>
        <div class="c">
          <blockquote class="with_quote_icon" style="border-left-color: #e699b2;background-color: rgba(251,207,192,0.5);">
            <i class="fa fa-quote-right" style="color: #e699b2;"></i>
            <h5 class="h5 blockquote-text" style="">
              {{$t('NonInvasivePrenatalTest.P9_1Title')}}
              <p>{{$t('NonInvasivePrenatalTest.P9_1Detail')}}</p>
              <p>{{$t('NonInvasivePrenatalTest.P9_1Detail2')}}</p>
            </h5>
          </blockquote>

          <blockquote class=" with_quote_icon" style="border-left-color: #e699b2;background-color: rgba(251,207,192,0.5);">
            <i class="fa fa-quote-right" style="color: #e699b2;"></i>
            <h5 class="h5 blockquote-text" style="">
              {{$t('NonInvasivePrenatalTest.P9_2Title')}}
              <p>{{$t('NonInvasivePrenatalTest.P9_2Detail')}}</p>
              <p>{{$t('NonInvasivePrenatalTest.P9_2Detail2')}}</p>
            </h5>
          </blockquote>
        </div>
      </img-card>
    </div>
  </div>
</template>

<script>
  import banner from '@/components/banner'
  import imgCard from './img-card'
  import box from './box'
  import hoverBox from '@/components/hover-box'

  export default {
    components: {
      banner,
      imgCard,
      hoverBox,
      box
    },
    data() {
      return {}
    },
    mounted() {
    },
    methods: {},
  }
</script>
<style scoped lang="scss">
  .v-non-invasive-prenatal-test {
    text-align: left;
    .p1 {
      background-color: #e699b2;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .card {
      padding-bottom: 30px;
    }


    .box-wrapper {
      display: flex;

      & > div {
        width: 16.67%;
      }
    }

    .p3 {
      .v-box {
        padding: 0;
      }
    }

    .p4 {
      padding-top: 120px;
      padding-bottom: 120px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url("../../assets/images/non-invasive-prenatal-test/header-nipt.jpg");
    }

    .p5 {
      background-color: rgba(251, 207, 192, 0.2);
      line-height: 27px;
      letter-spacing: 1px;
      font-size: 16px;

      ul {
        padding: 0;
        list-style: inside;
      }
    }

    .p7 {
      background-color: rgba(251, 207, 192, 0.2);
    }

    .p9 {
      background-color: rgba(251, 207, 192, 0.2);
      .card{
        padding-bottom: 10px;
      }
      .c {
        blockquote {
          h5 {
            font-size: 21px;
            line-height: 32px;
            letter-spacing: 0;
            text-transform: none;
            font-style: normal;
            font-weight: 300;
          }

          h5.blockquote-text {
            color: #cb3439;
          }

          &.with_quote_icon h5 {
            padding: 0 0 0 40px;
          }

          quotes: none;
          position: relative;
          padding: 14px 14px 14px 10px;
          border-left: 4px solid transparent;
        }

        i {
          float: left;
          font-size: 22px;
          color: #c1c0c0;
          margin: 6px 0 0 !important;
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .table-wrapper {
    text-align: center;
    line-height: 27px;
    letter-spacing: 1px;
    color: #3b3b3b;
    font-weight: 400;
    font-size: 16px;

    table#cu-table {
      padding-left: 5px !important;
    }

    table th {
      border: 0;
      padding: 5px 7px;
    }

    #cu-table caption {
      font-size: 2.532rem;
    }

    #cu-table {
      font-family: Microsoft\ JhengHei, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    #cu-table th {
      padding: 1.2307em 1.2307em 1em;
    }

    #cu-table th {
      padding-top: 12px;
      padding-bottom: 12px;
      font-family: Microsoft\ JhengHei, sans-serif;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      background-color: #efae9e;
      color: #fff;
    }

    #cu-table td {
      padding: .75em 1em .602em;
    }

    #cu-table tr:nth-child(even) {
      background-color: rgba(251, 207, 192, .2);
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/genedetection/non-invasive-prenatal-test.vue